const en = {
  firstDayWeek: 'First day of the week',
  startScreen: 'Start screen',
  blackTheme: 'Black theme',
  backgroundImage: 'Background image',
  language: 'Language',
  sounds: 'Sounds',
  home: 'Home',
  calendar: 'Calendar',
  settings: 'Settings',
  noTasks: 'No tasks',
  myTasks: 'My tasks',
  chooseImage: 'Choose background image:',
  saveChanges: 'Save changes',
  edit: 'Edit',
  add: 'Add',
  close: 'CLOSE',
  taskManager: 'Task manager'
};

export default en;
